function initRecentlyBought() {

    const notification = document.querySelector(".recently-bought");
    const closeBtn = notification.querySelector("[data-close-sale]");

    const data = JSON.parse(document.getElementById('ldt-popup__sales-JSON').textContent);
    const productsCount = data.idArray.length;
    const locationsCount = data.locationArray.length;
    const timesCount = data.timeArray.length;

    function updateNotification() {

        const productIndex = Math.floor(Math.random() * productsCount);
        const locationIndex = Math.floor(Math.random() * locationsCount);
        const timeIndex = Math.floor(Math.random() * timesCount);

        const formatedCompareAtPrice = new Intl.NumberFormat(`${Shopify.locale}`, { 
          style: 'currency', 
          currency: `${Shopify.currency.active}`
        }).format(data.compareAtpriceArray[productIndex] / 100);

        const formatedFinalPrice = new Intl.NumberFormat(`${Shopify.locale}`, { 
          style: 'currency', 
          currency: `${Shopify.currency.active}`
        }).format(data.priceArray[productIndex] / 100);

        document.querySelector('.recently-bought__img').src = data.imageArray[productIndex];
        document.querySelector('.recently-bought__product-title').href = data.urlArray[productIndex];
        document.querySelector('.recently-bought__product-title').textContent = data.titleArray[productIndex];
        document.querySelector('[data-location-sale]').textContent = data.locationArray[locationIndex];
        document.querySelector('[data-ago-sale]').textContent = data.timeArray[timeIndex];
        document.querySelector('.recently-bought__compare-at-price').textContent = data.compareAtpriceArray[productIndex] !== 99999 ? formatedCompareAtPrice : '';
        document.querySelector('.recently-bought__final-price').textContent = formatedFinalPrice;
        
    }

    let notificationTimeout;
    let notificationPaused = false; 
    let notificationInterval;
    
    function init() {
      if (localStorage.getItem('notificationClosed') === 'true') {
        return;
      }
    
      updateNotification();
      
      notification.classList.add("recently-bought--show");
    
      clearTimeout(notificationTimeout);
      notificationTimeout = setTimeout(() => {
        notification.classList.remove("recently-bought--show");
        
      }, notification.dataset.stayTime * 1000);
    }
    
    function startNotificationCycle(initial = false) {
      if (initial) {
        setTimeout(() => {
          init();
          startNotificationCycle(); 
        }, notification.dataset.startTime * 1000);
      } else {
        notificationInterval = setInterval(() => {
          if (!notificationPaused) {
            init();
          }
        }, notification.dataset.stayTime * 1000 + notification.dataset.startTime * 1000);
      }
    }
    
    startNotificationCycle(true);
    
    notification.addEventListener("mouseenter", () => {
      clearTimeout(notificationTimeout); 
      clearInterval(notificationInterval); 
      notificationPaused = true;
      
    });
    
    notification.addEventListener("mouseleave", () => {
      notificationPaused = false; 
    
      notificationTimeout = setTimeout(() => {
        notification.classList.remove("recently-bought--show");
      }, notification.dataset.stayTime * 1000);
    
      clearInterval(notificationInterval);
      startNotificationCycle();
    });
    
    if (localStorage.getItem('notificationClosed') === 'true') {
      localStorage.removeItem('notificationClosed');
    }
    
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        notification.classList.remove("recently-bought--show");
        localStorage.setItem('notificationClosed', 'true');
      });
    }

    

}

if ( document.querySelector(".recently-bought") ) {
  if (document.querySelector(".recently-bought").classList.contains("mobile-off") && window.innerWidth >= 768) {
    initRecentlyBought();  
  } else if (document.querySelector(".recently-bought").classList.contains("mobile-on")) {
    initRecentlyBought();  
  }
}


